"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = void 0;
var log_service_transport_1 = __importDefault(require("./log-service-transport"));
var devTools_1 = require("../devTools");
var version_1 = require("../../version");
var createLogger = function (clientId, sessionId, pageSessionId) {
    return new DefaultLogger(clientId, sessionId, pageSessionId);
};
exports.createLogger = createLogger;
var DefaultLogger = /** @class */ (function () {
    function DefaultLogger(clientId, sessionId, pageSessionId) {
        this.clientId = clientId;
        this.sessionId = sessionId;
        this.pageSessionId = pageSessionId;
        this.transport = new log_service_transport_1.default(clientId, sessionId, pageSessionId);
    }
    DefaultLogger.prototype.log = function (code, properties) {
        if (properties === void 0) { properties = {}; }
        var context = { version: version_1.SDK_VERSION };
        if (typeof window === 'undefined') {
            context['serverSide'] = true;
        }
        else {
            context['page'] = {
                url: window === null || window === void 0 ? void 0 : window.location.href,
                title: window === null || window === void 0 ? void 0 : window.document.title,
            };
        }
        if ((0, devTools_1.useConsoleLogger)()) {
            // eslint-disable-next-line no-console
            console.log("SXP SDK:", {
                clientId: this.clientId,
                sessionId: this.sessionId,
                pageSessionId: this.pageSessionId,
                code: code,
                properties: properties,
                context: context,
            });
        }
        else {
            this.transport.log(code, properties, context);
        }
    };
    return DefaultLogger;
}());
//# sourceMappingURL=index.js.map